import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

export default function Work() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("./Database/CaseStudy_work.json");
        const result = await response.json();
        setData(result.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted');
  };

  return (
    <div className="text-black font-sans min-h-screen flex flex-col justify-center items-center py-12">
      <div className="container mx-auto px-4 py-16">
        {/* Header Section */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h1 className="text-5xl font-extrabold tracking-tight leading-tight">
            Our Case Studies
          </h1>
          <p className="text-xl mt-4 max-w-2xl mx-auto text-gray-400">
            We create high-end products and experiences that accelerate your business growth.
          </p>
        </div>

        {/* Case Study Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.map((item) => (
            <div
              key={item.id}
              className="relative rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition-transform duration-300"
              data-aos="zoom-in"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-64 object-cover"
              />
              <div className="absolute bottom-4 right-4 bg-yellow-500 text-black p-2 rounded-full shadow-lg">
                +
              </div>
              <div className="p-4">
                <p className="text-xl font-bold">{item.title}</p>
                <p className="text-md text-gray-400">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action Button */}
        <Link to="/contact-us">
          <div className="flex justify-center items-center mt-12" data-aos="fade-up">
            <div className="bg-yellow-500 text-black py-3 px-6 rounded-full font-bold hover:shadow-lg hover:bg-black hover:text-green-600 cursor-pointer" data-aos="fade-up-right">
              LET'S BUILD TOGETHER
            </div>
          </div>
        </Link>
      </div>

      {/* Project Inquiry Form */}
      <div className="flex flex-col items-center justify-center w-full" data-aos="fade-up">
        <div className="rounded-lg shadow-lg flex flex-col md:flex-row max-w-4xl mx-auto">
          <div className="md:w-1/2 pr-10">
            <img
              src="https://static.vecteezy.com/system/resources/previews/000/158/932/large_2x/bookkeeping-vector-illustration.png"
              alt="Abstract glass object"
              className="w-full h-auto"
            />
          </div>
          <div className="md:w-1/2 p-6">
            <h1 className="text-4xl text-green-600 font-bold mb-6">Have a Project Idea?</h1>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row space-x-0 md:space-x-4">
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="block text-sm font-medium text-gray-700">Full Name</label>
                  <input
                    type="text"
                    required
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black"
                  />
                </div>
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="block text-sm font-medium text-gray-700">Email*</label>
                  <input
                    type="email"
                    required
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black"
                  />
                </div>
              </div>
              <div className="flex flex-col md:flex-row space-x-0 md:space-x-4">
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="block text-sm font-medium text-gray-700">Company Name</label>
                  <input
                    type="text"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black"
                  />
                </div>
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="block text-sm font-medium text-gray-700">Project Budget*</label>
                  <select className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black" required>
                    <option value="">Select Budget</option>
                    <option value="$100k and up">$100k and up</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Service Required*</label>
                <select className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black" required>
                  <option value="">Select Your Service</option>
                  <option value="App Development">App Development</option>
                  <option value="Digital Marketing">Digital Marketing</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Project Details*</label>
                <textarea
                  className="mt-1 block w-full border-b-2 border-gray-400 focus:outline-none focus:border-black"
                  rows="3"
                  required
                >
                  Tell us more about your idea
                </textarea>
              </div>
              <div className="flex justify-center mt-4 mb-2">
                <button type="submit" className="bg-black text-white py-2 px-6 rounded-full">
                  Send Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
